module.exports = __webpack_public_path__ + "f059b1bf068975fefc04b64f1bbb6a05.pdf";